import { render, staticRenderFns } from "./AddEditExtradataModal.vue?vue&type=template&id=fd0225f0&scoped=true"
import script from "./AddEditExtradataModal.vue?vue&type=script&lang=ts"
export * from "./AddEditExtradataModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0225f0",
  null
  
)

export default component.exports